import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLocationItems } from '../../services/api';
import { LocationValue } from '../../utils/common';

export const fetchLocationValues = createAsyncThunk('lov/fetchLocationValues', async () => {
  const data = await getLocationItems();
  return data;
});

interface LocationState {
  values: LocationValue[];
  loading: boolean;
  error: string | null;
}

const initialState: LocationState = {
  values: [],
  loading: false,
  error: null,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocationValues.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLocationValues.fulfilled, (state, action) => {
        state.values = action.payload;
        state.loading = false;
      })
      .addCase(fetchLocationValues.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default locationSlice.reducer;